export type WindowSize = {
  width: number | undefined;
  height: number | undefined;
};

export enum Direction {
  Up = 'up',
  Down = 'down',
}
